var map = {
	"./ALIOR-circle.png": 71980,
	"./CITI-circle.png": 24759,
	"./MBANK-circle.png": 28532,
	"./MILLENNIUM-circle.png": 1834,
	"./NEST-circle.png": 65919,
	"./PEKAO_BH-circle.png": 59225,
	"./PKO_BP-circle.png": 99716,
	"./SANTANDER-circle.png": 25256,
	"./VELO-circle.png": 4477
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21842;